import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { MaterialUIControllerProvider } from "context";
import { PublicationProvider } from "context/PublicationProvider";

const theme = createTheme();

// Examplad React Context Provider

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
    <PublicationProvider>
       <ThemeProvider theme={theme}>
        <App />
       </ThemeProvider>
      
      </PublicationProvider>

    </MaterialUIControllerProvider>
  </BrowserRouter>
);